import { gql } from '@apollo/client';

const schema = {
  changeFastSend: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $fast_send: Int) {
        updateOrder(ids: $ids, fast_send: $fast_send) {
          messages
        }
      }
    `,
  },
};

export default schema;
